import { PendingCustomerStatus } from '../data/useGetPendingCustomers';

export type PendingCustomersSearchFormValues = {
  status: PendingCustomerStatus | '';
};

export const EMPTY_FILTERS: PendingCustomersSearchFormValues = {
  status: '',
};
